import { reducerWithInitialState } from 'typescript-fsa-reducers';

interface RecommendDesignInjectController {
    // eslint-disable-next-line camelcase
    arrow_type: string;
    // eslint-disable-next-line camelcase
    order_type: string;
    designs: Array<any>;
}

export interface RecommendDesignState {
    items: Array<RecommendDesignInjectController>;
}

const initState: RecommendDesignState = {
    items: [],
};

export const recommendDesignReducer = reducerWithInitialState(initState);
